import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f9ddfeb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "dashboard-map-panel__fetching"
}
const _hoisted_2 = {
  key: 1,
  class: "dashboard-map-panel__stale"
}

import { computed, ref, watch } from 'vue';
import VietnamOperationsMap from '@/components/dashboard/map/VietnamOperationsMap.vue';
import WidgetState from '@/components/dashboard/WidgetState.vue';
import { useDashboardStore } from '@/core/hooks/useDashboardStore';
import { useDashboardMap } from '@/core/hooks/useDashboardMap';
import useCapDonVi from '@/core/hooks/use-cap-don-vi';
import type { DashboardMapItem } from '@/core/interfaces/Dashboard';


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardMapPanel',
  emits: ["selectMarker", "resetFocus"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const { fullscreenWidget, setFullscreenWidget, scope, permissions, capDonVi } =
  useDashboardStore();
const { capDonVi: authCapDonVi } = useCapDonVi();

const effectiveCapDonVi = computed(
  () => capDonVi.value ?? authCapDonVi.value ?? 2
);

const {
  data,
  isLoading,
  isFetching,
  isError,
  isStale,
  refetch,
  mapMode,
  markers: locatedMarkers,
  unlocatedCount,
  mapFocus,
  selectedMarkerId,
  selectMarker,
} = useDashboardMap();

/** Once the map has rendered, keep it mounted across drill-down refetches. */
const hasRenderedMap = ref(false);

watch(
  data,
  (next) => {
    if (next) {
      hasRenderedMap.value = true;
    }
  },
  { immediate: true }
);

const showInitialLoading = computed(
  () => !hasRenderedMap.value && isLoading.value && !data.value
);

const showInitialError = computed(
  () => !hasRenderedMap.value && isError.value && !data.value
);

const isFullscreen = computed(() => fullscreenWidget.value === 'map');

const canReset = computed(() => {
  const type = scope.value?.type;
  return type === 'unit' || type === 'warehouse';
});

function onSelectMarker(marker: DashboardMapItem): void {
  selectMarker(marker);
  emit('selectMarker', marker);
}

function onResetFocus(): void {
  emit('resetFocus');
}

function toggleFullscreen(): void {
  setFullscreenWidget(isFullscreen.value ? null : 'map');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["dashboard-map-panel", { 'dashboard-map-panel--fullscreen': isFullscreen.value }])
  }, [
    (showInitialLoading.value)
      ? (_openBlock(), _createBlock(WidgetState, {
          key: 0,
          variant: "loading",
          "loading-text": "Đang tải bản đồ...",
          onRetry: _unref(refetch)
        }, null, 8, ["onRetry"]))
      : (showInitialError.value)
        ? (_openBlock(), _createBlock(WidgetState, {
            key: 1,
            variant: "error",
            onRetry: _unref(refetch)
          }, null, 8, ["onRetry"]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            (_unref(isFetching))
              ? (_openBlock(), _createElementBlock("div", _hoisted_1))
              : _createCommentVNode("", true),
            (_unref(isStale))
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Dữ liệu cũ "))
              : _createCommentVNode("", true),
            (_unref(mapFocus))
              ? (_openBlock(), _createBlock(VietnamOperationsMap, {
                  key: 2,
                  mode: _unref(mapMode),
                  focus: _unref(mapFocus),
                  markers: _unref(locatedMarkers),
                  loading: _unref(isFetching),
                  "selected-marker-id": _unref(selectedMarkerId),
                  "unlocated-count": _unref(unlocatedCount),
                  "can-reset": canReset.value,
                  "show-financial": _unref(permissions).canViewFinancialValues,
                  "is-fullscreen": isFullscreen.value,
                  "cap-don-vi": effectiveCapDonVi.value,
                  onSelectMarker: onSelectMarker,
                  onResetFocus: onResetFocus,
                  onToggleFullscreen: toggleFullscreen
                }, null, 8, ["mode", "focus", "markers", "loading", "selected-marker-id", "unlocated-count", "can-reset", "show-financial", "is-fullscreen", "cap-don-vi"]))
              : _createCommentVNode("", true)
          ], 64))
  ], 2))
}
}

})